import { createReducer } from "@reduxjs/toolkit";
import { CAMERA_GET_ALL, CAMERA_ADD, CAMERA_DELETE } from "./action";
import { Camera } from "src/types/camera";

export type CameraState = {
  cameras: Camera[];
};

export const initialState: CameraState = {
  cameras: [],
};

const cameraReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(CAMERA_GET_ALL, (state, action) => {
      state.cameras = action.payload.cameras;
    })
    .addCase(CAMERA_ADD, (state, action) => {
      state.cameras.push(action.payload.camera);
    })
    .addCase(CAMERA_DELETE, (state, action) => {
      state.cameras = state.cameras.filter(
        (c) => c.deviceId !== action.payload.cameraId
      );
    })
);

export default cameraReducer;
